import { render, staticRenderFns } from "./VendorProjects.vue?vue&type=template&id=4051949f"
import script from "./VendorProjects.vue?vue&type=script&lang=js"
export * from "./VendorProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4051949f')) {
      api.createRecord('4051949f', component.options)
    } else {
      api.reload('4051949f', component.options)
    }
    module.hot.accept("./VendorProjects.vue?vue&type=template&id=4051949f", function () {
      api.rerender('4051949f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Vendors/VendorProjects.vue"
export default component.exports